import React from 'react';
import data from '../data.json';

export default function CulturalStripe() {
  const items = [...data.culturalStripe, ...data.culturalStripe]; // duplicate for seamless loop

  return (
    <div style={{
      background: 'var(--bg-dark)',
      borderTop: '1px solid var(--border)',
      borderBottom: '1px solid var(--border)',
      padding: '16px 0',
      overflow: 'hidden',
    }}>
      <div style={{
        display: 'flex',
        animation: 'scrollLeft 30s linear infinite',
        width: 'max-content',
      }}
        onMouseEnter={e => e.currentTarget.style.animationPlayState = 'paused'}
        onMouseLeave={e => e.currentTarget.style.animationPlayState = 'running'}
      >
        {items.map((item, i) => (
          <div key={i} style={{
            display: 'flex', alignItems: 'center', gap: 9,
            padding: '0 32px', fontSize: 12.5, fontWeight: 600,
            color: 'var(--gray-500)',
            borderRight: '1px solid var(--border)',
            whiteSpace: 'nowrap',
          }}>
            <span style={{ fontSize: 16 }}>{item.icon}</span>
            {item.text}
          </div>
        ))}
      </div>
    </div>
  );
}
